import {ValueObject} from '@s-ui/domain'

export class VehicleAiSeoContentValueObject extends ValueObject {
  #description

  constructor({description}) {
    super()
    this.#description = description
  }

  get description() {
    return this.#description
  }

  get value() {
    return {
      description: this.#description
    }
  }

  static createFromApi({content} = {}) {
    const {description} = content
    return new VehicleAiSeoContentValueObject({
      description
    })
  }
}
